export default "__VITE_ASSET__a19f4e69__"